import { format, isToday, isYesterday } from 'date-fns'

const ROLE_STYLES = {
  admin: {
    border: 'border-amber-300',
    bg: 'bg-[#fffdf7]',
    text: 'text-amber-700',
  },
  sales: {
    border: 'border-sky-200',
    bg: 'bg-sky-50',
    text: 'text-sky-700',
  },
  purchase: {
    border: 'border-emerald-200',
    bg: 'bg-emerald-50/70',
    text: 'text-emerald-700',
  },
}

function formatDate(date) {
  const d = new Date(date)

  if (isToday(d)) {
    return `Today · ${format(d, 'HH:mm')}`
  }

  if (isYesterday(d)) {
    return `Yesterday · ${format(d, 'HH:mm')}`
  }

  return format(d, 'dd MMM yyyy · HH:mm')
}

export default function CommentCard({ comment }) {
  const role = comment.author?.role?.toLowerCase()

  const style = ROLE_STYLES[role] || ROLE_STYLES.sales

  return (
    <div className={`rounded-[20px] border p-3 ${style.border} ${style.bg}`}>
      <div className=" flex items-start justify-between">
        <div>
          <p className={`text-[14px] font-bold uppercase ${style.text}`}>
            {comment.author?.name} ({comment.author?.role})
          </p>
        </div>

        <div className="flex items-center gap-2">
          <p className="text-xs text-muted-foreground">
            {formatDate(comment.createdAt)}
          </p>
        </div>
      </div>

      <p className="whitespace-pre-wrap text-[13px] leading-7 text-slate-800">
        {comment.message}
      </p>
    </div>
  )
}
